import { Component, OnInit } from '@angular/core';
import { Transition } from '@uirouter/angular';
import { TranslatePipe } from '@ngx-translate/core';

import {
    TrainingPlanningAgency,
    TrainingPlanningAgencyService,
} from '../../../_services/technical';

@Component({
    selector: 'jhi-trainings',
    templateUrl: 'detail.component.html',
    styleUrls: ['detail.component.scss'],
    providers: [TranslatePipe],
})
export class TrainingPlanningAgencyDetailComponent implements OnInit {
    currentPSA: TrainingPlanningAgency;
    nextPSA: TrainingPlanningAgency;
    id: any;

    constructor(
        private trainingPlanningAgencyService: TrainingPlanningAgencyService,
        private trans: Transition
    ) {}

    ngOnInit() {
        this.id = this.trans.params()['id'];
        if (this.id !== 'new') {
            this.load(this.id);
        } else {
            this.currentPSA = new TrainingPlanningAgency(
                undefined,
                'Nouvelle agence',
                ''
            );
            this.nextPSA = new TrainingPlanningAgency(undefined, '', '');
        }
    }

    load(id) {
        this.trainingPlanningAgencyService.findPSA(id).subscribe((psa) => {
            this.currentPSA = psa;
            this.nextPSA = Object.assign({}, psa);
        });
    }

    save() {
        if (this.id !== 'new') {
            this.trainingPlanningAgencyService.edit(this.nextPSA).subscribe();
        } else {
            this.trainingPlanningAgencyService.new(this.nextPSA).subscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/training-planning-agency/detail/detail.component.ts